import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import Warning from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import SnackbarContent from '@mui/material/SnackbarContent';

const icons = {
  warning: Warning,
  success: CheckCircleIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const variantSx = {
  error: {
    backgroundColor: 'error.dark',
    color: '#ffffff',
  },
  info: {
    backgroundColor: 'info.main',
    color: '#ffffff',
  },
  success: {
    backgroundColor: 'primary.dark',
    color: '#ffffff',
  },
  warning: {
    backgroundColor: 'warning.dark',
    color: '#ffffff',
  },
};

const MessageBox = ({ message, variant = 'error', inline, slim = false, className, action, sx }) => {
  if (!message) {
    return null;
  }
  const Icon = icons[variant];
  return (
    <SnackbarContent
      sx={[
        { maxWidth: '100%', width: '100%' },
        variantSx[variant],
        inline && { width: 'initial' },
        slim && { height: '37px' },
        sx,
      ]}
      className={className}
      action={action}
      message={
        <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
          <Icon sx={{ fontSize: '20px', opacity: 0.9, mr: 1 }} />
          {message}
        </Box>
      }
    />
  );
};

export default MessageBox;
